import i18n from '@/i18n'

const CoverStatus = {
  PENDING: 'Pending',
  QUOTED: 'Quoted',
  ACTIVATED: 'Activated',
  REJECTED: 'Rejected',
  CANCELLED: 'Cancelled',
  SETTLED: 'Settled',
  CLAIMED: 'Claimed',
  EXPIRED: 'Expired',
  TIMEBARRED: 'TimeBarred',
  ASSESSING: 'Assessing',
  LATE: 'Late'
}
const ERROR_CODES = {
  '0001': 'Login.SignUp.TOKEN_EXPIRED_ERROR',
  '1008': 'Cover.RequestCover.CANNOT_REFUSE_ERROR',
  '1089': 'Cover.RequestCover.CANNOT_REFUSE_PROPOSAL_ERROR',
  '1032': 'Cover.RequestCover.CANNOT_ACTIVATE_ERROR',
  '1005': 'Cover.RequestCover.CANNOT_ACTIVATE_PROPOSAL_ERROR',
  '1007': 'Cover.RequestCover.CANNOT_ACTIVATE_INSOLVENT_ERROR',
  '2001': 'Login.SignUp.EMAIL_EXISTS_ERROR',
  '1313': 'Cover.RequestCover.FAILED_UPDATE_COVER_ERROR',
  '1029': 'Cover.RequestCover.EXCEED_COVER_DURATION_ERROR',
  '1033': 'Cover.RequestCover.EXCEED_AMOUNT_AT_QUOTE_ERROR'
}

const DOCUMENT_FILE_TYPES = {
  'Invoice': { default: 'File.FileType.COPY_OF_THE_INVOICE_DESC', br: 'Copy of the invoice (nota fiscal)' },
  'ProofOfDelivery': { default: 'File.FileType.PROOF_OF_DELIVERY_DESC', br: 'Proof of delivery (comprovante de entrega)' },
  'PurchaseOrder': { default: 'File.FileType.COPY_OF_PURCHASE_ORDER_DESC' },
  'PowerOfAttorney': { default: 'File.FileType.POWER_OF_ATTORNEY_DESC' },
  'PaymentTitle': { default: 'File.FileType.PAYMENT_TITLE_DESC', br: 'Payment title (boleto or duplicata)' },
  'CreditRestriction': { default: 'File.FileType.CREDIT_RESTRICTION_DESC', br: 'Credit restriction (PEFIN or protesto)' },
  'DeliveryNotes': { default: 'File.FileType.DELIVERY_NOTES_DESC', br: 'Delivery notes' },
  'TermsAndConditionsOfSale': { default: 'File.FileType.TERMS_AND_CONDITIONS_OF_SALE_DESC', br: 'Copy of the terms and conditions of sale/Contract between supplier and buyer' },
  'AdditionalDocuments': { default: 'File.FileType.ADDITIONAL_DOCUMENTS_DESC', br: 'Additional documents' },
  'ProofOfDebt': { default: 'File.FileType.PROOF_OF_DEBT_DESC', br: 'Proof of Debt' },
  'AccountStatement': { default: 'File.FileType.ACCOUNT_STATEMENT_DESC', br: 'Account Statement' }
}

const VALIDATION_RULES = {
  'coverId': [
    v => ((!v || v.length === 0) || (new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$')).test(v)) || i18n.t('Cover.ListCover.SEARCH_COVER_ID_ERROR')
  ]
}

export default {
  CoverStatus,
  ERROR_CODES,
  DOCUMENT_FILE_TYPES,
  VALIDATION_RULES
}
